import { render, staticRenderFns } from "./person_details.vue?vue&type=template&id=1c188afb"
import script from "./person_details.vue?vue&type=script&lang=js"
export * from "./person_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports